module.exports = __webpack_public_path__ + "img/蜂蜜4.68d1bec6.png";